var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-scroll-view",
    { attrs: { tag: "w-container" } },
    [
      _c(
        "transition",
        { attrs: { name: "fast-fade", mode: "out-in" } },
        [
          !_vm.isChildRoute
            ? _c(
                "w-row",
                [
                  _c(
                    "w-col",
                    [
                      _c(
                        "w-card",
                        [
                          _c("w-card-title", [
                            _vm._v(_vm._s(_vm.$ct("plugins"))),
                          ]),
                          _c(
                            "w-list",
                            [
                              _c(
                                "w-list-item",
                                { attrs: { to: "/settings/plugins/cashdro" } },
                                [
                                  _c("w-list-item-text", [
                                    _vm._v(
                                      " " + _vm._s(_vm.$ct("cashdro")) + " "
                                    ),
                                  ]),
                                ],
                                1
                              ),
                              _c(
                                "w-list-item",
                                { attrs: { to: "/settings/plugins/display" } },
                                [
                                  _c("w-list-item-text", [
                                    _vm._v(
                                      " " + _vm._s(_vm.$ct("cashier")) + " "
                                    ),
                                  ]),
                                ],
                                1
                              ),
                              _c(
                                "w-list-item",
                                { attrs: { to: "/settings/plugins/shop" } },
                                [
                                  _c("w-list-item-text", [
                                    _vm._v(" " + _vm._s(_vm.$ct("shop")) + " "),
                                  ]),
                                ],
                                1
                              ),
                              _c(
                                "w-list-item",
                                { attrs: { to: "/settings/plugins/car" } },
                                [
                                  _c("w-list-item-text", [
                                    _vm._v(
                                      " " + _vm._s(_vm.$ct("carpass")) + " "
                                    ),
                                  ]),
                                ],
                                1
                              ),
                              _c(
                                "w-list-item",
                                {
                                  attrs: { to: "/settings/plugins/sendcloud" },
                                },
                                [
                                  _c("w-list-item-text", [
                                    _vm._v(
                                      " " + _vm._s(_vm.$ct("sendcloud")) + " "
                                    ),
                                  ]),
                                ],
                                1
                              ),
                              _c(
                                "w-list-item",
                                { attrs: { to: "/settings/plugins/codabox" } },
                                [
                                  _c("w-list-item-text", [
                                    _vm._v(
                                      " " + _vm._s(_vm.$ct("codabox")) + " "
                                    ),
                                  ]),
                                ],
                                1
                              ),
                              _c(
                                "w-list-item",
                                { attrs: { to: "/settings/plugins/desktop" } },
                                [
                                  _c("w-list-item-text", [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$ct("winfakt-desktop-server")
                                        ) +
                                        " "
                                    ),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _c("router-view"),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }